import { render, staticRenderFns } from "./RemoteProgramsList.vue?vue&type=template&id=4c588da8&"
import script from "./RemoteProgramsList.vue?vue&type=script&lang=js&"
export * from "./RemoteProgramsList.vue?vue&type=script&lang=js&"
import style0 from "./RemoteProgramsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports